// extracted by mini-css-extract-plugin
export default {"discountIconWrapper":"DiscountFooter-rebranding-module__discountIconWrapper___3X88h"};